import { render, staticRenderFns } from "./Myfooter.vue?vue&type=template&id=3fefc5c4&scoped=true&"
import script from "./Myfooter.vue?vue&type=script&lang=js&"
export * from "./Myfooter.vue?vue&type=script&lang=js&"
import style0 from "./Myfooter.vue?vue&type=style&index=0&id=3fefc5c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.0_css-loader@6.7.1_vue-template-compiler@2.7.4_webpack@5.73.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fefc5c4",
  null
  
)

export default component.exports